"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleEvent = void 0;
const Schedule_1 = require("./Schedule");
const debug = !process.env.AWS_SESSION_TOKEN && false;
class ScheduleEvent {
    constructor({ positiveSchedules, startMs, stopMs }) {
        this.getOccurances = (fromMs, toMs) => {
            const from = Math.max(this.startMs ?? 0, fromMs);
            const to = Math.min(this.stopMs ?? Infinity, toMs);
            debug &&
                console.log(`ScheduleEvent getOccurences with  ${new Date(fromMs).toString()} and ${new Date(toMs).toString()} using ${new Date(from).toString()}  to ${new Date(to).toString()}`);
            this.stopMs && debug && console.log(`ScheduleEvent getOccurences this.stopMs is date ${new Date(this.stopMs).toString()} `);
            const res = this.positiveSchedules.reduce((acc, curr) => {
                return [...acc, ...curr.getOccurances(from, to)];
            }, []);
            debug && console.log('positiveSchedules', this.positiveSchedules);
            return res.sort();
        };
        this.getOccuranceDatesLocal = (fromMs, toMs) => {
            return this.getOccurances(fromMs, toMs).map((ms) => new Date(ms).toString());
        };
        this.addSchedule = (schedule) => {
            this.positiveSchedules.push(new Schedule_1.CronSchedule(schedule));
        };
        this.removeSchedule = (scheduleId) => {
            const idx = this.positiveSchedules.findIndex((schedule) => schedule.id === scheduleId);
            if (idx !== -1) {
                this.positiveSchedules.splice(idx, 1);
            }
        };
        this.positiveSchedules = positiveSchedules.map((cronScheduleProps) => new Schedule_1.CronSchedule(cronScheduleProps));
        this.startMs = startMs;
        this.stopMs = stopMs;
    }
}
exports.ScheduleEvent = ScheduleEvent;
